import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 relative h-64 lg:h-[500px]" style={{ backgroundColor: "oklch(0.96 0.03 80)" }}>
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20community%20gathering%20scene%20with%20people%20sharing%20news%20on%20phones%20soft%20natural%20lighting%20modern%20cafe%20setting%20editorial%20photography%20warm%20tones%20authentic%20moments&width=900&height=1000&seq=cta-community&orientation=portrait"
            alt="吃瓜社区氛围"
            className="w-full h-full object-cover object-top"
            title="加入51吃瓜爆料社区"
          />
          <div className="absolute top-6 left-6">
            <span className="text-xs font-medium text-foreground-500">Community</span>
          </div>
          <div className="absolute bottom-6 left-6">
            <h3 className="text-2xl md:text-3xl font-black font-heading text-foreground-900 leading-tight">
              加入我们<br />一起<strong className="text-primary-500">吃瓜</strong>
            </h3>
          </div>
        </div>

        <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center py-14 px-6 md:px-14">
          <div className="text-center max-w-md">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-4">
              免费加入<br />吃瓜社区
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8">
              每日大瓜首发曝光，网红黑料一网打尽。关注我们，不错过任何一个劲爆爆料。
              更有独家信源不定期放送猛料，让你走在吃瓜第一线。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/about" className="btn-dark cursor-pointer">
                了解更多 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
              <Link to={`/category/wanghong`} className="btn-outline cursor-pointer">
                立即吃瓜
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}